import React from 'react';
import ReactDOM from 'react-dom/client'; // Note a mudança aqui
import App from './App';
import { createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';
import reducer from './_reducers';
import registerServiceWorker, { unregister } from './registerServiceWorker';
import 'bootstrap/dist/css/bootstrap.css';
import './index.css';

const store = createStore(reducer, applyMiddleware(thunk))

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Provider store={store}>
        <App />
    </Provider>
);

//registerServiceWorker();
unregister();